import _assign from 'lodash/assign'
import { aggregateTotals } from '~/lib/util/basket'

export const getters = {
  // Get the basket.id
  id(state) {
    return state.id
  },

  // Get the full Basket payload
  payload(state) {
    return state
  },

  // Get the Upsell Basket data
  upsell(state) {
    return state.upsell
  },

  // TODO TO REMOVE
  // Get the numOfItems data
  numOfItems(state) {
    return state.numOfItems
  },

  // Get the num_of_items data
  num_of_items(state) {
    return state.num_of_items
  },

  // Get the BasketItem List
  items(state) {
    return state.items
  },

  // Get the BasketItem by ID
  item: state => id => {
    return state.items.find(i => i.id === id)
  },

  // get all up_sell products present in the basket
  items_up_sell(state) {
    const uniqueUpSellProducts = []

    const seenIds = new Set()

    state.items.forEach(item => {
      const upSellProducts = item.up_sell || []
      upSellProducts.forEach(product => {
        const { sku, enabled } = product
        console.log(`items_up_sell sku=${sku} enabled=${enabled}`)
        if (enabled && !seenIds.has(sku)) {
          seenIds.add(sku)
          uniqueUpSellProducts.push(product)
        }
      })
    })

    return uniqueUpSellProducts
  },

  // get all cross_sell products present in the basket
  items_cross_sell(state) {
    const uniqueCrossSellProducts = []

    const seenIds = new Set()

    state.items.forEach(item => {
      const crossSellProducts = item.cross_sell || []
      crossSellProducts.forEach(product => {
        const { sku, enabled } = product
        if (!enabled) {
          return
        }

        console.log(`items_cross_sell sku=${sku} enabled=${enabled}`)
        const isAlreadyPresentInBasket = state?.items?.find(e => e?.offer?.sku === sku)
        if (!isAlreadyPresentInBasket && !seenIds.has(sku)) {
          seenIds.add(sku)
          uniqueCrossSellProducts.push(product)
          // uniqueCrossSellProducts.push(product)
        }
      })
    })

    return uniqueCrossSellProducts
  }
}

export const mutations = {
  id(state, payload) {
    state.id = payload
  },

  // Injest the Basket payload
  payload(state, payload) {
    _assign(state, payload)
    if (payload) {
      state.discount = {}
      if (payload?.discount?.amount && payload?.discount?.description) {
        state.discount = payload.discount
      }
    }
  },

  // Injest the Basket Upsell payload
  upsell(state, payload) {
    state.upsell = [...payload]
  },

  // Create the new Basket Totals
  aggregateTotals(state) {
    // console.log('aggregateTotals state.basket=', state)
    if (state?.items?.length >= 1) {
      // console.log('aggregateTotals state.basket.items=', state.items)
      // TODO MongoDB INTEGRATION
      const newTotals = aggregateTotals(state)
      // console.log('aggregateTotals newTotals=', newTotals)
      state.totals = { ...newTotals }
    }
  },

  item(state, item) {
    const index = state.items.findIndex(i => i.id === item.id)
    state.items[index] = { ...item }
  },

  items(state, payload) {
    state.items = [...payload]
    state.numOfItems = state?.items?.length
    state.num_of_items = state?.items?.length
  }
}

export const state = () => ({
  // Basket ID
  id: undefined,

  // The Basket Items
  items: [],

  // The num of Basket Items
  numOfItems: 0,

  // The num of Basket Items
  num_of_items: 0,

  // Basket Saving in GBP
  save: undefined,

  // Basket Total in GBP
  total: undefined,

  // Basket Discount
  discount: undefined,

  // Aggregated Basket Totals in GBP
  totals: undefined,

  // UpdatedAt time
  updatedAt: undefined,

  // Upsell Page data
  upsell: []
})

export const namespaced = true
